import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { getSeoRoutes } from "@/lib/seoRoutes";
import { onConsentMaybeInit } from "@/lib/analytics";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Route manifest for scripts/prerender.mjs: CRA data modules are ESM and cannot be
// imported from a CommonJS Node script, so the manifest travels through the browser.
window.__SEO_ROUTES__ = getSeoRoutes();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
);

onConsentMaybeInit();
